module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('vbl-checkbox', {
    model: {
      value: (_vm.isCheck),
      callback: function($$v) {
        _vm.isCheck = $$v
      },
      expression: "isCheck"
    }
  }, [_vm._v(" 是")])], 1), _c('div', [_vm._v("\n        " + _vm._s(_vm.isCheck) + "\n    ")]), _c('br'), _c('div', [_c('vbl-checkbox', {
    attrs: {
      "true-value": 1,
      "false-value": 0
    },
    model: {
      value: (_vm.isCheck1),
      callback: function($$v) {
        _vm.isCheck1 = $$v
      },
      expression: "isCheck1"
    }
  }, [_vm._v(" 是")])], 1), _c('div', [_vm._v("\n        " + _vm._s(_vm.isCheck1) + "\n    ")]), _c('br'), _c('vbl-checkbox', {
    attrs: {
      "native-value": 0
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_vm._v("香蕉")]), _c('vbl-checkbox', {
    attrs: {
      "native-value": 1
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_vm._v("苹果")]), _c('vbl-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_vm._v("禁用")]), _c('p', [_vm._v(_vm._s(_vm.val))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43958d67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblCheckbox/example/vblCheckboxExample.vue
// module id = 259
// module chunks = 0